/* eslint-disable require-jsdoc */
import {PdfNodeBase} from "./pdfNodeBase.js";

export class PdfLineNode extends PdfNodeBase {
	constructor(_UUID) {
		super(_UUID);
	}
}
